const DibbleConfigs = {
    apiEndpoint: {
        'development': 'https://dev.giverise.app/api',
        'production': 'https://dev.giverise.app/api'
    },
    downloadInvoiceUri: {
        'development': 'https://staging.lvbh.marinapro.app/backend/api/download_file.php?',
        'production': 'https://api.lvbh.marinapro.app/backend/api/download_file.php?'
    }
};

export default DibbleConfigs;
